import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-cobalt/20 bg-white p-6 shadow-sm shadow-cobalt/5" data-id="element-176" data-mp="3fxb40lzxjwdr">
      <span className="w-fit rounded-full bg-cobalt/10 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-cobalt-deep" data-id="element-177" data-mp="36zilza2tqamo">
        Testimonianza da inserire
      </span>
      <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/80" data-id="element-178" data-mp="2x0tf0ccgual7">{t.text}</p>
      <div className="mt-6 flex items-center gap-3" data-id="element-179" data-mp="2x2w3grxyzvnt">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cobalt text-sm font-bold text-white" data-id="element-180" data-mp="2s2i7475qea5m">
          {t.initials}
        </span>
        <div data-id="element-181" data-mp="qac1oyvee8zv">
          <p className="text-sm font-bold text-ink" data-id="element-182" data-mp="q9tzllm210k1">{t.name}</p>
          <p className="text-xs text-ink/60" data-id="element-183" data-mp="q896m0fe1poa">{t.city}</p>
          <p className="text-xs italic text-cobalt-deep" data-id="element-184" data-mp="h4wsxwwqs2fk">{t.role}</p>
        </div>
      </div>
    </article>;
}
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + testimonials.length) % testimonials.length);
  }, []);
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-185" data-mp="c8y282nxy8bz">
      <div className="mx-auto max-w-5xl" data-id="element-186" data-mp="zxhc2mmn2t66">
        <div className="mx-auto max-w-2xl text-center" data-id="element-187" data-mp="zysd4eop9mtl">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-188" data-mp="14u7nuxrev2ls">
            La parola ai docenti di chimica
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-189" data-mp="v5g0z417j8hq">
            Spazio riservato alle testimonianze autentiche dei docenti che utilizzano CHIMICA
            VISIVA™.
          </p>
        </div>

        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-190" data-mp="1nlqsta4zwqqg">
          {testimonials.map((t, i) => <Card key={i} t={t} data-id="element-191" data-mp="1xi91r6l6d9by" data-mpi={i} />)}
        </div>

        <div className="mt-10 md:hidden" data-id="element-192" data-mp="1xfmvdaa0szvb">
          <div className="relative overflow-hidden" data-id="element-193" data-mp="1sio3kydtx50a">
            <AnimatePresence mode="wait" data-id="element-194" data-mp="1sh37h4bv9e0b">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-195" data-mp="1ogj9jyjgy6d4">
                <Card t={testimonials[index]} data-id="element-196" data-mp="19soh8j9di40k" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-197" data-mp="14sjzkpwqb38r">
            <button type="button" onClick={() => go(-1)} aria-label="Testimonianza precedente" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-198" data-mp="10rqb9vfdjmfc">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-199" data-mp="32h5x8bqo6zmc" />
            </button>

            <div className="flex gap-2" data-id="element-200" data-mp="37g0dp7160c3a">
              {testimonials.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Vai alla testimonianza ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-cobalt' : 'w-2 bg-cobalt/30'}`} data-id="element-201" data-mp="37hto8xewfggk" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Testimonianza successiva" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-202" data-mp="2sr49jl28bj7y">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="2519x34ltnwo8" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}